<template>
    <div class="input-group mb-3">
        <input
            type="text"
            class="form-control border-1 input-name"
            :placeholder="$t('product.name_placeholder')"
            aria-label="name"
            v-model="name"
            aria-describedby="basic-addon1"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'NameInput',

    computed: {
        ...mapGetters({
            filtersSet: 'product/filtersSet',
            filters: 'product/filters',
        }),
    },

    data() {
        return {
            myInterval: '',
            name: ''
        }
    },

    methods: {
        emitName() {
            this.filtersSet.name.value = this.filters.name
            this.$emit('emitName')
        }
    },

    watch: {
        name(value) {
            if (value && value.length) {
                this.filters.name = value
                clearInterval(this.myInterval);
                this.myInterval = setTimeout(this.emitName, 1000);
            }
        },
        'filters.name'(value) {
            if (!value || value.length === 0) {
                this.name = ''
            }
        }
    }
}
</script>

<style scoped>
.input-name::placeholder {
    font-size: 12px;
}
</style>